<template>
  <section id="whatsapp-cdr">
    <v-container>
      <v-skeleton-loader v-if="isLoading" class="mt-8" type="table"> </v-skeleton-loader>

      <v-row v-else dense justify="end">
        <v-col cols="auto">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                small
                fab
                v-bind="attrs"
                v-on="on"
                color="info"
                @click="rangeDialogActive = true"
                :loading="isDownloadingReport"
              >
                <v-icon>mdi-download</v-icon>
              </v-btn>
            </template>
            <span>Descargar Reporte</span>
          </v-tooltip>
        </v-col>

        <v-col cols="12" md="auto" class="mb-4">
          <v-text-field
            filled
            rounded
            dense
            append-icon="mdi-magnify"
            label="Buscar"
            single-line
            readonly
            hide-details
            @click="isOpenSearch = true"
          ></v-text-field>
        </v-col>
        <v-col cols="12">
          <v-data-table
            :headers="headers"
            :items="tableData"
            class="elevation-0"
            :loading="isLoadingTable"
            :options.sync="tableOptions"
            :server-items-length="totalItems"
            :footer-props="{
              'items-per-page-options': [15, 30, 50, 100],
            }"
          >
            <template v-slot:[`item.typeTicketId`]="{ item }">
              <v-icon size="24" v-if="item.typeTicketId === 1 || item.typeTicketId === 4" color="green green-darken-2">
                mdi-whatsapp
              </v-icon>
              <v-icon size="30" v-else-if="item.typeTicketId === 2" color="blue-grey">
                mdi-web
              </v-icon>
              <img
                style="width: 30px !important"
                v-else-if="item.typeTicketId === 3"
                src="@/assets/icons/telegram.png"
                alt="Telegram icono"
              />
              <v-icon size="24" v-else-if="item.typeTicketId === 5" color="pink">
                mdi-instagram
              </v-icon>
              <v-icon size="24" v-else-if="item.typeTicketId === 6" color="blue">
                mdi-whatsapp
              </v-icon>
              <v-icon size="24" v-else-if="item.typeTicketId === 7" color="blue">
                mdi-facebook-messenger
              </v-icon>
              <v-icon size="24" v-else-if="item.typeTicketId === 8" color="grey">
                mdi-email-outline
              </v-icon>
            </template>

            <template v-slot:[`item.queue`]="{ item }">
              <v-list-item dense two-line class="pl-0">
                <template>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ item.queue ? item.queue.name : "" }}
                    </v-list-item-title>

                    <v-list-item-subtitle>
                      {{ item.queue ? item.queue.number : "" }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </template>
              </v-list-item>
            </template>

            <template v-slot:[`item.created_at`]="{ item }">
              <v-list-item dense two-line class="pl-0">
                <template>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ item.created_at | dateFormat }}
                    </v-list-item-title>

                    <v-list-item-subtitle>
                      {{ item.created_at | getHourFormat }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </template>
              </v-list-item>
            </template>

            <template v-slot:[`item.status`]="{ item }">
              <v-chip
                x-small
                class="ma-2 text-capitalize"
                :color="item.status === 'closed' ? 'light' : item.status === 'open' ? 'success' : 'info'"
              >
                <!-- <v-icon left size="16">
                  {{
                    item.status === "closed"
                      ? "mdi-close-circle-outline"
                      : item.status === "open"
                      ? "mdi-adjust"
                      : ""
                  }}
                </v-icon> -->
                {{ item.status }}
              </v-chip>
            </template>

            <template
              v-slot:[`item.estado`]="{
                item,
              }"
            >
              <v-chip color="transparent" small>
                <v-icon left small :color="getSpanishState(item.estado).color"
                  >{{ getSpanishState(item.estado).icon }}
                </v-icon>
                {{ getSpanishState(item.estado).text }}
              </v-chip>
            </template>

            <template v-slot:[`item.action`]="{ item }">
              <v-hover v-slot:default="{ hover }">
                <v-btn text icon :color="hover ? 'accent' : 'blue-grey'" @click="handleOpenMessage(item)">
                  <v-icon>mdi-eye</v-icon>
                </v-btn>
              </v-hover>

              <v-menu bottom left>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn text icon v-bind="attrs" v-on="on">
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>

                <v-list>
                  <v-list-item @click="handleChat('closed', item.id)">
                    <v-list-item-title>
                      Resolver
                    </v-list-item-title>
                  </v-list-item>

                  <!--<v-list-item @click="handleChat('closedTip')">
                    <v-list-item-title>
                      Resolver y tipificar
                    </v-list-item-title>
                  </v-list-item> -->

                  <!-- <v-list-item @click="handleChat('pending')">
                    <v-list-item-title>Devolver</v-list-item-title>
                  </v-list-item> -->

                  <v-list-item @click="OpenAgentDialog('user', item.id)">
                    <v-list-item-title>Transferir a usuario</v-list-item-title>
                  </v-list-item>

                  <v-list-item @click="OpenAgentDialog('queue', item.id)">
                    <v-list-item-title>Transferir a cola</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>

    <message-dialog
      v-if="isOpenMessages"
      :open="isOpenMessages"
      :ticket="selectedTicket"
      @dialog:close="closeMessageDialog"
    >
    </message-dialog>
    <search-dialog
      :open="isOpenSearch"
      @dialog:submit="handleSendSearch"
      @dialog:close="closeSearchDialog"
    ></search-dialog>

    <transferChatDialog
      v-if="transferChatDialog"
      :transferType="transferType"
      :isActive="transferChatDialog"
      :currentAgentId="userId"
      @dialog:close="closeAgentDialog"
    ></transferChatDialog>

    <!-- MODAL DE RANGO DE FECHA -->
    <RangeDateDialog
      v-if="rangeDialogActive"
      :active="rangeDialogActive"
      :id="id"
      module="ReportCdrChat"
      @dialog:change="eventdialog"
    ></RangeDateDialog>
  </section>
</template>

<script>
import moment from "moment";
// import vuescroll from "vuescroll";
import { mapState } from "vuex";
import { PbxHttpClient } from "@/services/httpclient";
import SearchDialog from "@/components/CDR/Whatsapp/SearchDialog.vue";
import MessageDialog from "@/components/CDR/Whatsapp/MessageDialog.vue";
import transferChatDialog from "@/components/chats/transferChatDialog.vue";
import RangeDateDialog from "@/components/DatePickers/DateRangePicker";

export default {
  name: "CDR-Whatsapp",

  inject: ["theme"],

  components: {
    // vuescroll,
    transferChatDialog,
    MessageDialog,
    SearchDialog,
    RangeDateDialog,
  },

  data() {
    return {
      rangeDialogActive: false,
      isDownloadingReport: false,
      isLoading: false,
      isLoadingTable: false,
      isOpenMessages: false,
      isOpenSearch: false,
      transferChatDialog: false,
      transferType: "",
      userId: null,
      searchData: {},
      active: false,
      selectedTicket: null,
      headers: [
        {
          text: "Tipo",
          value: "typeTicketId",
          align: "center",
          width: "5%",
          sortable: false,
        },
        {
          text: "Fecha/Hora",
          value: "created_at",
          width: "10%",
        },
        {
          text: "Línea",
          value: "config.number",
          width: "10%",
        },
        { text: "Cola", value: "queue", width: "15%" },
        { text: "Agente", value: "user_name.name", width: "15%" },
        {
          text: "Contacto",
          value: "contacts.name",
          width: "15%",
        },
        { text: "Número", value: "contactNumber", width: "15%" },
        {
          text: "Estado",
          value: "status",
          width: "15%",
          align: "center",
        },
        {
          text: "Acciones",
          align: "center",
          value: "action",
          filterable: false,
          width: "15%",
        },
      ],
      tableData: [],
      tableOptions: {},
      totalItems: 0,
    };
  },

  computed: {
    isDark() {
      return this.$vuetify.theme.dark;
    },
  },

  watch: {
    isDark() {
      this.changeThemeChart();
    },

    tableOptions: {
      handler() {
        this.getList();
      },
      deep: true,
    },
  },

  methods: {
    eventdialog() {
      this.rangeDialogActive = false;
    },

    // Resolver un chat en activo
    async handleChat(status, id, value) {
      try {
        // this.isLoading = true;
        // console.log("aqui");
        const date = moment().format("YYYY-MM-DD HH:mm:ss");

        // console.log("aqui2");
        let payload = {
          status: status,
          unreadMessages: 0,
        };
        // console.log("aqui3");

        if (status === "closed") {
          payload.closedTime = date;
          payload.typing = false;
        }

        // if (status === "closedTip") {
        //   payload.closedTime = date;
        //   payload.status = "closed";
        //   payload.typing = true;
        // }

        if (status === "pending") payload.userId = null;

        if (status === "transfer") {
          payload.status = "pending";

          if (this.transferType === "user") {
            payload.userId = value;
            payload.toOPerDate = date;
          } else if (this.transferType === "queue") {
            payload.unreadMessages = 0;
            payload.userId = null;
            payload.queueId = value;
          }
        }

        if (status === "queue") {
          payload.status = "pending";
          payload.userId = null;
          payload.toOPerDate = date;
        }

        const { data } = await PbxHttpClient.put(`/whatsapps/update_ticket/${id}`, payload);

        this.getList();

        // this.dataUserActiveChat = {
        //   id: null,
        //   contactId: null,
        //   name: "",
        //   avatar: "",
        //   whatsapp: "",
        //   phone1: ""
        // };

        // this.getChatsList();
        // this.messagesList = [];

        if (status === "closed") this.$snotify.success("Ticket cerrado con éxito.", "¡Hecho!");
        // else if (status === "closedTip") {
        //   this.temporaryTable_id = data.temporaryTable_id;
        //   this.openTypificationDialog();
        // }
      } catch (err) {
        this.$snotify.error("No se pudo cerrar el chat.", "¡Error!");
      }

      // this.isLoading = false;
    },

    OpenAgentDialog(TransferTo, id) {
      this.userId = id;
      this.transferType = TransferTo;
      // if (TransferTo === "user") this.transferChatDialog = true;
      // else if (TransferTo === "queue") this.handleChat("queue");
      this.transferChatDialog = true;
    },
    closeAgentDialog(value) {
      if (value) this.handleChat("transfer", this.userId, value);
      this.transferChatDialog = false;
    },

    async getList(search = null) {
      if (search) this.searchData = search;
      if (!this.tableData.length) this.isLoading = true;
      this.$store.commit("layout/SET_OVERLAY", {
        value: true,
        title: "Cargando",
      });
      this.isLoadingTable = true;
      const page = this.tableOptions.page || 1;
      const itemPerPage = this.tableOptions.itemsPerPage || 15;
      try {
        const res = await PbxHttpClient.post(`/whatsapps/chat/admin/index_admin`, this.searchData, {
          params: { page, itemPerPage },
        });
        this.tableData = res.data.data;
        this.totalItems = res.data.total;
      } catch (err) {
        this.$snotify.error("Hubo un error en la consulta.", "Error");
        console.log(err);
      }
      this.isLoadingTable = false;
      this.isLoading = false;
      this.$store.commit("layout/SET_OVERLAY", { value: false, title: "" });
    },

    handleOpenMessage(item) {
      this.selectedTicket = item;
      this.isOpenMessages = true;
    },
    handleSendSearch(search) {
      this.tableOptions.page = 1;
      this.getList(search);
      this.closeSearchDialog();
    },
    closeMessageDialog() {
      this.selectedTicket = null;
      this.isOpenMessages = false;
    },
    closeSearchDialog() {
      this.isOpenSearch = false;
    },
  },
};
</script>

<style>
.shadow-1 {
  -webkit-box-shadow: 0 8px 16px 0 rgba(40, 40, 90, 0.09), 0 3px 6px 0 rgba(0, 0, 0, 0.065);
  box-shadow: 0 8px 16px 0 rgba(40, 40, 90, 0.09), 0 3px 6px 0 rgba(0, 0, 0, 0.065);
}

audio {
  height: 35px !important;
}
</style>
